import React from "react";
import { PackValidationContext } from "./pack-validation-context-props.ts";

const usePackValidationContext = () => {
    const context = React.useContext(PackValidationContext);
    if (context === undefined) {
        throw new Error("usePackValidationContext must be used within a PackValidationProvider");
    }
    return context;
};

export default usePackValidationContext;